import React, { useState } from 'react'

import Accordions from '../../../../components/accordions/accordions'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import NO_RESULTS from '../../../../utils/constants/no-results'
import { DELETE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import AddEditView from './add-edit-view'

const PmgFolders = ({
  canAdd = false,
  fetchFiles,
  folders,
  inEditMode,
  onAccourdion,
  onAdd,
  onCancel,
  onDelete,
  onEdit,
  setFetchFiles,
  showAddEdit,
}: any) => {
    const [showAlert, setShowAlert] = useState(false)
    const [fileToDelete, setFileToDelete] = useState('')
    const [filePath, setFilePath] = useState('')
  const accordionContent = (folders: any) => {
    return (
      <PmgFolders
        canAdd={true}
        fetchFiles={fetchFiles}
        folders={folders}
        inEditMode={inEditMode}
        onAccourdion={onAccourdion}
        onAdd={onAdd}
        onCancel={onCancel}
        onDelete={onDelete}
        onEdit={onEdit}
        setFetchFiles={setFetchFiles}
        showAddEdit={showAddEdit}
      />
    )
  }
  const addButtonArr = canAdd
    ? [
        {
          alabel: 'Add',
          className:
            'btn-border btn-xs font-0 font-xxl-14 btn-border-radius3 ms-auto color-primary text-nowrap',
          icon: 'icon-add me-xxl-1 font-10',
          label: 'Add',
          onClick: onAdd,
        },
      ]
    : []

  const onClickAlert = async (button: string) => {
    if (button === 'OK') {
      setShowAlert(false)
      onDelete(fileToDelete, filePath)
      setFilePath('')
      setFileToDelete('')
    } else {
      setShowAlert(false)
      setFilePath('')
      setFileToDelete('')
    }
  }

  return (
    <div className='container'>
      <div className='row m-0'>
        {showAlert && (
          <Alert
            alerttextclass='poppins-semibold font-13 text-center'
            btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
            btn1iconclassNmae='icon-checked font-12 pe-1'
            btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
            btn2iconclassNmae='icon-close color-primary font-12 pe-1 breakall'
            cancel='Cancel'
            className='alert-info'
            message={DELETE_MESSAGE}
            onClick={onClickAlert}
            yes='OK'
          />
        )}
        <div className='p-0 settings-main'>
          {folders?.length > 0 ? (
            <div>
              <Accordions
                accordionitemclass=' shadow card mb-2 my-2 mx-2'
                actions={addButtonArr}
                className='accordions'
                count='bordered px-1 ms-1 border-radius'
                dataobj={onAccourdion}
                defaultActivekey='1'
                dividerClass='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block'
                extrasClass='d-flex flex-column align-items-center flex-md-row flex-nowrap w-100 last-child-hide'
                headerextras={[
                  {
                    classq:
                      'breakall w-100 min-w-md-100 max-w-md-100 d-flex me-auto align-items-center',
                    name: 'Templates',
                  },
                  {
                    classq: 'breakall w-100 min-w-md-100 max-w-md-100',
                    name: 'Created',
                  },
                  {
                    classq: 'breakall w-100 min-w-md-100 max-w-md-100',
                    name: 'Modified',
                  },
                ]}
                inputProps={{
                  accordionheadClass: 'd-flex align-items-center px-2 py-3 custombg',
                  className: 'justify-content-start poppins-medium font-13 w-100 p-0',
                  contentclassName: 'p-0',
                }}
                isFolder={true}
                isSettings={true}
                items={folders}
                renderHtml={folders.length > 0 ? accordionContent : ''}
                titleIcon='icon-open-folder font-16 color-primary pe-2'
                titleclassName='title-color35 poppins-semibold font-12'
                titlecollapsedIcon='icon-close-folder pe-2 font-16 color-primary'
                titlecontentclassName='poppins-semibold font-12 title-color2 lineClamp2 pe-2'
              />
            </div>
          ) : (
            <>
              {inEditMode.status && inEditMode.rowKey === folders.Id ? (
                <div className='mb-4'>
                  <AddEditView
                    addFile={true}
                    fetchFiles={fetchFiles}
                    onCancel={onCancel}
                    path={`/${folders.Id.split('-')[0]}/${folders.Id.split('-')[1]}`}
                    setFetchFiles={setFetchFiles}
                    showAddEdit={true}
                  />
                </div>
              ) : (
                ''
              )}
              {folders?.files?.length > 0 ? (
                folders?.files.map((file) => (
                  <div className='d-flex flex-column shadow card mb-2 p-2' key={file.title}>
                    <div className='d-flex'>
                      <div className='d-flex flex-column flex-md-row flex-nowrap w-100'>
                        <div className='breakall w-100 min-w-md-100 max-w-md-100 d-flex me-auto align-items-center'>
                          <div className='icon-emptyfile pe-1 font-14 color-primary'></div>
                          <div>
                            {' '}
                            <a
                              className='color-primary poppins-medium font-12'
                              // eslint-disable-next-line @stylistic/max-len
                              href={file?.serverRelativeUrl}
                            >
                              {file.title}
                            </a>
                          </div>
                        </div>
                        <div className='dividerdashed vertical mx-2 mx-xxl-3 d-none d-md-block my-1'></div>
                        <div className='breakall w-100 min-w-md-100 max-w-md-100'>
                          <div className='title-color35  poppins-medium font-12'>Created</div>
                          <div className='poppins-medium font-12 title-color'>{file?.created}</div>
                        </div>
                        <div className='dividerdashed vertical mx-2 mx-xxl-3 d-none d-md-block my-1'></div>
                        <div className='breakall w-100 min-w-md-100 max-w-md-100'>
                          <div className='title-color35  poppins-medium font-12'>Modified</div>
                          <div className='poppins-medium font-12 title-color'>{file?.modified}</div>
                        </div>
                        <div className='dividerdashed vertical mx-2 mx-xxl-3 d-none d-md-block my-1'></div>
                      </div>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex gap-1'>
                          <Buttons
                            aria-label='Edit'
                            className='btn-border btn-xs font-0 font-xxl-14 btn-border-radius3 ms-auto color-primary text-nowrap'
                            icon='icon-pencil me-xxl-1 font-10'
                            label='Edit'
                            onClick={() => onEdit(file)}
                            value={file?.Name}
                          />
                          <Buttons
                            aria-label='Delete'
                            className='btn-border btn-xs font-0 font-xxl-14 btn-border-radius3 ms-auto color-primary text-nowrap'
                            icon='icon-trashbin me-xxl-1 font-10'
                            label='Delete'
                            onClick={() => {
                              setShowAlert(true)
                              setFileToDelete(file)
                              setFilePath(`/${folders.Id.split('-')[0]}/${folders.Id.split('-')[1]}`)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {inEditMode.status && inEditMode.rowKey === file.Id ? (
                      <AddEditView
                        editFile={true}
                        editedFile={file}
                        fetchFiles={fetchFiles}
                        fileName={file.title}
                        onCancel={onCancel}
                        path={`/${folders.Id.split('-')[0]}/${folders.Id.split('-')[1]}`}
                        setFetchFiles={setFetchFiles}
                        showAddEdit={true}
                      />
                    ) : (
                      ''
                    )}
                  </div>
                ))
              ) : (
                <div className='min-h-200 d-flex align-items-center justify-content-around'>
                  <div>
                    <NO_RESULTS />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default PmgFolders
